import { Provider } from "react-redux";
import store from "./store/store";

export function HotelProviders({ children }) {
  return <Provider store={store}>{children}</Provider>;
}
